import { render } from "./Avatar.vue?vue&type=template&id=ffa3e3b8&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=ffa3e3b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ffa3e3b8"

export default script